import React from 'react';
const Footer = (props) => {
    return (React.createElement("div", { id: "footer", className: `${props.colored ? 'milkybrownlight' : 'white'} ${props.yellow ? 'yellow' : ''}`, "data-testid": "footer" }, props.children));
};
export default Footer;
